import React from "react"
import { Col, Row, FormGroup, Label, Input } from "reactstrap"
import DocumentDataInput from "../DocumentDataInput/DocumentDataInput"
import DocumentDataSelect from "../DocumentDataInput/DocumentDataSelect"
import { groupFieldsByCategory, categoryNameMapping, isSelectField, isLinkField, isValidUrl } from "../DocumentModal/utils"

const getCountryAndStateCodes = (fieldCode, data) => {
    const suffixValue = fieldCode.includes('_') ? `_${fieldCode.split('_').pop()}` : ''
    const findValue = key =>
        data.find(f => f.fieldCode === `${key}${suffixValue}`)?.value ||
        data.find(f => f.fieldCode === key)?.value
    return { countryCode: findValue('COUNTRY'), stateCode: findValue('STATE') }
}

const DocumentFields = ({ documentTypeDocumentData, allInputsFilled, handleFieldChange, mainUsAddresCheck = false, mainUsAddressCheckHandler = () => { }, driverCountry = null }) => {
    const platformField = documentTypeDocumentData && documentTypeDocumentData.find(item => item.fieldCode.startsWith("PLATFORM"))
    const platformCode = platformField ? platformField.value : undefined
    const groupedFields = groupFieldsByCategory(documentTypeDocumentData || [])

    const renderExternalLink = (field) => (
        <a
            href={field.value.startsWith("http") ? field.value : `https://${field.value}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Open link in new tab"
        >
            <i className="fa fa-external-link fa-sm"></i>
        </a>
    )

    const handleCheckChange = (e) => {
        mainUsAddressCheckHandler(e.target.checked)
    }
    return (
        <Col xs={12} style={{ marginTop: "20px" }}>
            {!allInputsFilled && <Label for="documentDataInputs">Please complete all required fields</Label>}
            {Object.keys(groupedFields).map((category) => {
                const categoryName = categoryNameMapping[category] || ""
                return (
                    <FormGroup key={category}>
                        <Label className="document-category-label">{categoryName}</Label>
                        <Row style={{ marginBottom: "10px" }}>
                            {groupedFields[category].map((field, index) => (
                                <Col className="data-field" xs={4} key={index}>
                                    <Label>{field.displayName.toUpperCase() || ""} {isLinkField(field.fieldCode) && isValidUrl(field.value) ? renderExternalLink(field) : null}</Label>
                                    {isSelectField(field.fieldCode) ? (
                                        <DocumentDataSelect field={{ ...field, platformCode: field.fieldCode === 'CATEGORY' ? platformCode : field.platformCode }} handleDriverDataChange={handleFieldChange}  {...getCountryAndStateCodes(field.fieldCode, documentTypeDocumentData)} />
                                    ) : (
                                        <DocumentDataInput
                                            field={field}
                                            handleDriverDataChange={handleFieldChange}
                                        />)
                                    }
                                </Col>
                            ))}
                            {
                                driverCountry === "US" &&
                                    categoryName === "Address Information" ? (
                                    <Col xs={4} className="data-field">
                                        <Label>Is this the main address?</Label>
                                        <Input type="checkbox" onChange={handleCheckChange} checked={mainUsAddresCheck} />
                                    </Col>
                                ) : <></>
                            }
                        </Row>
                    </FormGroup>
                )
            })}
        </Col>
    )
}

export default DocumentFields

